/** Copy of the Send feedback dialog and its menu rows. */
export const FEEDBACK_COPY = {
  title: "Send feedback",
  description: "Tell us what is on your mind. It goes straight to the product team.",
  close: "Close",
  cancel: "Cancel",
  kindLegend: "What kind of feedback?",
  kinds: {
    bug: { label: "Bug", messageLabel: "What went wrong?", placeholder: "What did you expect, and what happened instead?", submit: "Send bug report" },
    idea: { label: "Feature idea", messageLabel: "What would you like to see?", placeholder: "Describe the idea and the problem it would solve.", submit: "Send idea" },
    kudos: { label: "Kudos", messageLabel: "What worked well?", placeholder: "Tell us what you liked.", submit: "Send kudos" },
  },
  messageRequired: "Please write a message.",
  messageMax: 5000,
  screenshotAdd: "Add screenshot",
  screenshotHint: "or paste an image",
  screenshotRemove: "Remove screenshot",
  screenshotAlt: "Screenshot preview",
  screenshotType: "Use a png, jpeg or webp image.",
  screenshotSize: "The screenshot must be 5 MB or smaller.",
  includeDetails: "Include this page and browser details",
  fallbackError: "We could not send your feedback. Please try again.",
  sentTitle: "Thanks, we got it",
  sentBody: "Your feedback reached the product team.",
} as const;

export type FeedbackKind = keyof typeof FEEDBACK_COPY.kinds;

/** Copy of the Help & support rows in both help menus. */
export const HELP_SUPPORT_COPY = {
  section: "Help & support",
  liveChat: "Live chat",
  online: "Online",
  feedback: "Send feedback",
  feedbackHint: "Bug, idea, kudos",
  email: "Email us",
  soon: "Coming soon",
} as const;
